import { jsxs as _, jsx as t, Fragment as g } from "react/jsx-runtime";
import { c as s } from "../../../clsx-OuTLNxxd.js";
import { R as v } from "../../../main-D0W7FGpj.js";
import "../../../button.types-DcITT54g.js";
import { IconButton as f } from "../button/iconButton/iconButton.js";
import { L as x } from "../../../link-Cudl80Ct.js";
import { T as z } from "../../../text-BVbFy3oz.js";
const b = "_pagination_120z2_29", N = "_active_120z2_50", a = {
  pagination: b,
  "pagination-item": "_pagination-item_120z2_36",
  "pagination-ellipse": "_pagination-ellipse_120z2_37",
  active: N,
  "pagination-previous": "_pagination-previous_120z2_65",
  "pagination-next": "_pagination-next_120z2_66",
  "pagination-small": "_pagination-small_120z2_72"
}, k = 7;
function B({ page: c, totalPages: n, onPageChange: u, labelOf: d = "of" }) {
  const e = c > n ? n : c >= 1 ? c : 1, { isMobile: o } = v(), p = (i) => {
    i >= 1 && i <= n && u(i);
  }, h = () => {
    const i = [];
    if (n <= k)
      for (let r = 1; r <= n; r++)
        i.push(r);
    else {
      i.push(1), e >= 5 && i.push("...");
      let r, l;
      e < 5 ? (r = 2, l = 5) : e > n - 4 ? (r = n - 4, l = n - 1) : (r = e - 1, l = e + 1);
      for (let m = r; m <= l; m++)
        i.push(m);
      e <= n - 4 && i.push("..."), i.push(n);
    }
    return i;
  };
  if (!(n < 2))
    return /* @__PURE__ */ _("div", { className: s(a.pagination, o && a["pagination-small"]), children: [
      /* @__PURE__ */ t(
        f,
        {
          icon: o ? "circle-left-arrow" : "angle-left",
          size: o ? "5xl" : "large",
          "aria-label": "Previous",
          onClick: () => p(e - 1),
          disabled: e === 1,
          className: s(a["pagination-item"], a["pagination-previous"])
        }
      ),
      o && /* @__PURE__ */ t(z, { children: `${e} ${d} ${n}` }),
      !o && /* @__PURE__ */ t(g, { children: h().map((i, r) => i === "..." ? /* @__PURE__ */ t("div", { className: s(a["pagination-ellipse"]), children: "..." }, r) : /* @__PURE__ */ t(
        x,
        {
          noUnderline: !0,
          onClick: () => typeof i == "number" ? p(i) : null,
          className: s(a["pagination-item"], i === e && a.active),
          disabled: e === i,
          children: i
        },
        r
      )) }),
      /* @__PURE__ */ t(
        f,
        {
          icon: o ? "circle-right-arrow" : "angle-right",
          size: o ? "5xl" : "large",
          "aria-label": "Next",
          onClick: () => p(e + 1),
          disabled: e === n,
          className: s(a["pagination-item"], a["pagination-next"])
        }
      )
    ] });
}
export {
  B as Pagination
};
